import React, { createContext, useContext, useState } from 'react';

interface CourseReportContextType {
  selectedCourse: string;
  setSelectedCourse: React.Dispatch<React.SetStateAction<string>>
  selectedUser: string;
  setSelectedUser: React.Dispatch<React.SetStateAction<string>>
  courseDetails: string;
  setCourseDetails: React.Dispatch<React.SetStateAction<string>>
  userDatum: string;
  setUserDatum: React.Dispatch<React.SetStateAction<string>>
  groupReportSnapshot: string;
  setGroupReportSnapshot: React.Dispatch<React.SetStateAction<string>>
  selectedQuiz: string;
  setSelectedQuiz: React.Dispatch<React.SetStateAction<string>>
  datePicker: string;
  setDatePicker: React.Dispatch<React.SetStateAction<string>>
  teamData: string;
  setTeamData: React.Dispatch<React.SetStateAction<string>>
  siteOption: string
  setSiteOption: React.Dispatch<React.SetStateAction<string>>
}

const CourseReportContext = createContext<CourseReportContextType | null>(null);

export const CourseReportProvider: React.FC = ({ children }) => {
  const [selectedCourse, setSelectedCourse] = useState('')
  const [selectedUser, setSelectedUser] = useState('')
  const [courseDetails, setCourseDetails] = useState('')
  const [userDatum, setUserDatum] = useState('')
  const [groupReportSnapshot, setGroupReportSnapshot] = useState('')
  const [selectedQuiz, setSelectedQuiz] = useState('') 
  const [datePicker, setDatePicker] = useState('')
  const [teamData, setTeamData] = useState('')
  const [siteOption, setSiteOption] = useState('')

  return (
    <CourseReportContext.Provider value={{ 
      selectedCourse,
      setSelectedCourse,
      selectedUser,
      setSelectedUser,
      courseDetails,
      setCourseDetails,
      userDatum,
      setUserDatum,
      groupReportSnapshot,
      setGroupReportSnapshot,
      selectedQuiz,
      setSelectedQuiz,
      datePicker,
      setDatePicker,
      teamData,
      setTeamData,
      siteOption,
      setSiteOption
    }}>
      {children}
    </CourseReportContext.Provider>
  )
}

export const useCourseReport = (): CourseReportContextType => {
  const context = useContext(CourseReportContext)
  if (!context) {
    throw new Error('useCourseReport must be used within a CourseReportProvider');
  }
  return context
}
